import React from 'react'

const DetailsContext = React.createContext({})

export const DetailsProvider = DetailsContext.Provider

export default DetailsContext